import "../../css/pages/caseStudiesDetail.scss";
import BasePage from "./base";
import boxedItem from "../modules/boxedItem";

class CaseStudiesDetail extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onLoad() {
        super.onLoad();
        boxedItem.setMobileView();
    }
}

new CaseStudiesDetail();
